
type listenerModel = {
    name?: string;
    priority?: number;
    doing: ()=>void
}

class HandleListener {
    private _model: listenerModel

    constructor(model: listenerModel) {
        this._model = model
    }

    do = () => {
        this._model.doing();
    };

    get doing(){
        return this._model.doing
    }

    set doing(val){
        this._model.doing = val
    }

    get name() {
        return this._model.name;
    }

    get priority() {
        return this._model.priority;
    }
}

export { HandleListener }